import $ from 'jquery';

$(() => {
  const loadMoreButton = $('.Cards.class .Button-load-more');

  if (!loadMoreButton) {
    return;
  }

  const cardsContainer = $('.Cards.class .Card-wrapper');
  const cards = $('.Cards.class .Card-wrapper .ClassCard');
  const show = cardsContainer.data('show');

  cards.slice(show).each((i, card) => {
    card.style.display = 'none';
  });

  loadMoreButton.on('click', (e) => {
    e.preventDefault();

    loadMoreButton.hide();

    cards.slice(show).each((i, card) => {
      card.style.display = 'block';
    });
  });
});
